module.exports = __webpack_public_path__ + "img/ziz1.e2e038c7.png";